export default __webpack_public_path__ + "static/product-photo-3eff6101896e0a77748dad8f5fb4da12.png";